module.exports = __webpack_public_path__ + "img/float-add.6fcd63ce.png";